let isHeaderScroll = $(window).scrollTop() > 70 ? 'scroll' : 'noscroll'

headerAdapt()
headerScroll()

$(window).on('resize', function () {
    headerAdapt()

    if ($(window).outerWidth() > 1023) {
        $('.js_modal-cart__recomended').removeClass('active')
    }
})

$(document).on('scroll', function() {
    headerScroll()
})

$('.js_side-menu__wrapper').on('scroll', function() {
    sideMenuHeight()
})

$(document).on('click', '.js_search-open', function () {
    if ($('.js_search').hasClass('active')) {
        closeSearch()
    } else {
        $('.js_search').addClass('active')
    }
})

$(document).on('click', '.js_phones-open', function () {
    if ($('.js_phones').hasClass('active')) {
        closePhones()
    } else {
        $('.js_phones').addClass('active')
    }
})

$(document).on('click', function (e) {
    let target = $(e.target)
    if (!target.closest('.js_search').length && !target.closest('.js_search-open').length) {
        closeSearch()
    }
    if (!target.closest('.js_phones').length && !target.closest('.js_phones-open').length) {
        closePhones()
    }
    if (!target.closest('.js_modal-cart__recomended').length) {
        $('.js_modal-cart__recomended').removeClass('active')
    }
})

$(document).on('click', '.js_search-find', function () {
    let value = $(this).siblings('.js_search-input').val()
    console.log(value)
})

$(document).on('keydown', function (e) {
    if ($('.js_search-input').is(':focus')) {
        if (e.keyCode == 13) {
            $('.js_search-find').click()
        } else if (e.keyCode == 27) {
            closeSearch()
        }
    }
})

$(document).on('click', '.js_header__open-menu', function () {
    $('.js_side-menu').addClass('active')
    setTimeout(function () {
        $('.js_side-menu__wrapper').css('transform', 'translateX(0)')
    }, 100)
    $('body').css('overflow', 'hidden')
})

$(document).on('click', '.js_side-menu__close', function () {
    closeSideMenu()
})

$(document).on('click', '.js_side-menu', function(e) {
    if (!$(e.target).closest('.js_side-menu__wrapper').length) {
        closeSideMenu()
    }
})

$(document).on('click', '.js_header__nav-link', function(e) {
    if ($(window).outerWidth() < 1024) {
        e.preventDefault()
        $(this).siblings('.js_side-menu__menu').addClass('active')
        $('.js_side-menu__wrapper').addClass('side-menu__wrapper_no-scroll')
    }
})

$(document).on('click', '.js_header__submenu-link', function(e) {
    if ($(window).outerWidth() < 1024) {
        e.preventDefault()
        $(this).siblings('.js_header__subitems').addClass('active')
    }
})

$(document).on('click', '.js_side-menu__menu-back', function() {
    $(this).closest('.js_side-menu__menu').removeClass('active')
    $('.js_side-menu__wrapper').removeClass('side-menu__wrapper_no-scroll')
})

$(document).on('click', '.js_header__subitems-back', function() {
    $(this).closest('.js_header__subitems').removeClass('active')
})

$(document).on('click', '.js_modal-cart__recomended-btn', function() {
    const recomendedWrapper = $(this).closest('.js_modal-cart__recomended')
    recomendedWrapper.toggleClass('active')
})

function headerScroll() {
    if ($(window).scrollTop() > 70) {
        $('.js_header').addClass('header_scroll')
    } else {
        $('.js_header').removeClass('header_scroll')
    }
}

function closeSearch() {
    $('.js_search').removeClass('active')
    $('.js_search-input').val('')
}

function closePhones() {
    $('.js_phones').removeClass('active')
}

function headerAdapt() {
    if ($(window).outerWidth() > 1023) {
        closeSideMenu()
        $('.js_header__langs').appendTo('.js_header__menu-container')
        $('.js_header__nav-list').appendTo('.js_header__nav')
        $('.js_header__links-list').appendTo('.js_header__main-links')
        $('.js_header__phones-wrapper').appendTo('.js_phones')
    } else {
        $('.js_header__langs').appendTo('.js_side-menu__langs')
        $('.js_header__nav-list').appendTo('.js_side-menu__nav')
        $('.js_header__links-list').appendTo('.js_side-menu__links')
        $('.js_header__phones-wrapper').appendTo('.js_side-menu__phones')
    }
}

function closeSideMenu() {
    $('.js_side-menu__wrapper').removeAttr('style')
    setTimeout(function() {
        $('.js_side-menu').removeClass('active')
    }, 300)
    $('body').removeAttr('style')
    $('.js_side-menu__menu').removeClass('active')
    $('.js_header__subitems').removeClass('active')
    $('.js_side-menu__wrapper').removeClass('side-menu__wrapper_no-scroll').scrollTop(0)
    $('.js_side-menu .js_side-menu__menu').removeAttr('style')
}

function sideMenuHeight() {
    let height = $('.js_side-menu__wrapper').scrollTop() + 70
    $('.js_side-menu .js_side-menu__menu').css('top', height + 'px')
}